import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  ClusterDetails,
  ClusterDetailsVariables
} from "./types/ClusterDetails";
import { ClusterList, ClusterListVariables } from "./types/ClusterList";

// import {
//   AnnouncementDetails,
//   AnnouncementDetailsVariables
// } from "./types/AnnouncementDetails";
// import {
//   AnnouncementList,
//   AnnouncementListVariables
// } from "./types/AnnouncementList";

export const clusterList = gql`
  ${pageInfoFragment}
  query ClusterList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: ClusterInput
  ) {
    clusters(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
    ) {
      edges {
        node {
          id
          name
          productType {
            id
            name
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;
export const useClusterListQuery = makeQuery<ClusterList, ClusterListVariables>(
  clusterList
);

export const clusterDetails = gql`
  query ClusterDetails($id: ID!) {
    cluster(id: $id) {
      id
      name
      productType {
        id
        name
      }
      lowerPrepTimeDays
      lowerPrepTimeHours
      lowerPrepTimeMins
      upperPrepTimeDays
      upperPrepTimeHours
      upperPrepTimeMins
    }
  }
`;
export const useClusterDetailsQuery = makeQuery<
  ClusterDetails,
  ClusterDetailsVariables
>(clusterDetails);
